export const getFormkitSelectComponentName = (
  isMultiSelect: MaybeRefOrGetter<boolean>,
) => (toValue(isMultiSelect) ? 'FormkitMultiSelect' : 'FormkitSingleSelect')
